/**
 * WhatsHappening — consolidates Trending / New / Updated / Most Viewed into
 * one compact tabbed module (replaces the four stacked homepage rails).
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { TrendingUp, Plus, RefreshCw, Eye } from "lucide-react";
import { SectionHeader, MiniRow } from "./homeShared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TABS = [
  { key: "trending", label: "Trending", icon: TrendingUp },
  { key: "new", label: "New", icon: Plus },
  { key: "updated", label: "Updated", icon: RefreshCw },
  { key: "most_viewed", label: "Most Viewed", icon: Eye },
];

const WhatsHappening = () => {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("trending");

  useEffect(() => {
    let dead = false;
    axios.get(`${API}/home/whats-happening`, { timeout: 12000 })
      .then((r) => { if (!dead) setData(r.data); })
      .catch(() => {});
    return () => { dead = true; };
  }, []);

  if (!data) return null;
  const rows = data[tab] || [];

  return (
    <section data-testid="home-whats-happening" className="border-t" style={{ borderColor: "#2D2A26", background: "#08070A" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 md:py-20">
        <SectionHeader
          file="File 006 · Signal Traffic"
          title="What’s Happening"
          subtitle="One feed, four signals — what the Archive is surfacing right now."
        />
        <div className="border" style={{ borderColor: "#2D2A26", background: "#0F0E12" }}>
          <div className="flex overflow-x-auto border-b [scrollbar-width:none]" style={{ borderColor: "#2D2A26" }}>
            {TABS.map(({ key, label, icon: Icon }) => {
              const active = tab === key;
              return (
                <button
                  key={key}
                  data-testid={`whats-happening-tab-${key}`}
                  onClick={() => setTab(key)}
                  className={`flex items-center gap-1.5 md:gap-2 px-3.5 md:px-6 py-3 md:py-3.5 font-mono text-[9px] md:text-[10px] uppercase tracking-[0.2em] md:tracking-[0.3em] whitespace-nowrap border-b-2 -mb-px transition-colors ${
                    active ? "text-[#E4DFD3]" : "text-[#8A8377] hover:text-[#A39E93]"
                  }`}
                  style={{ borderColor: active ? "#D92D20" : "transparent" }}
                >
                  <Icon size={12} className={active ? "text-[#D92D20]" : ""} />
                  {label}
                </button>
              );
            })}
          </div>
          <div key={tab} className="px-4 md:px-6 py-2 motion-safe:animate-in motion-safe:fade-in motion-safe:duration-300" data-testid="whats-happening-rows">
            {rows.map((d, i) => (
              <MiniRow key={d.slug} dossier={d} index={i} testid={`whats-happening-row-${i}`} />
            ))}
            {rows.length === 0 && (
              <div className="py-6 font-mono text-[10px] uppercase tracking-[0.3em] text-[#454038]">No signals yet</div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatsHappening;
